module.exports = __webpack_public_path__ + "img/imgentrew1.edd089d1.png";